<!-- Toolbar -->
<phscw-toolbar
    componentIdentifier="global-help"
    [componentConnection]="$any(this)"
    [buttonAdd]="allowNewHelpentry"
    [buttonFullscreen]="true"
    [buttonClose]="true"
    [fullscreenSize]="90"
    [fullscreenStatus]="fullscreenStatus">
</phscw-toolbar>
